import { Dispatch, SetStateAction } from "react";

import { Profile } from "@/api/auth/auth.types.ts";

export enum UpdateProfileTab {
  FORM = "Form",
  PICTURES = "Pictures",
  PIN_CODE = "PinCode",
  INTERFACE_LANG = "InterfaceLang",
  CONTENT_LANG = "ContentLang",
  RECOMMENDATIONS = "Recommendations",
}

export interface UpdateProfileProps {
  profile: Profile;
  tab: UpdateProfileTab;
  setTab: Dispatch<SetStateAction<UpdateProfileTab>>;
}
export interface UpdateProfileProps {
  profile: Profile;
  tab: UpdateProfileTab;
  setTab: Dispatch<SetStateAction<UpdateProfileTab>>;
}
